<template>
  <div class="rounded-md">
    <form @submit.prevent="submit">
      <loading :status="loading"></loading>
      <template v-if="isDemoMode">
        <div class="bg-yellow-100 rounded-lg py-5 text-center">
          <strong class="text-gray-400">Click to login as below while demo mode &#128512;</strong>
          <div class="mt-2 text-center">
            <button
              class="btn btn-app rounded-none rounded-l-md"
              type="button"
              @click.prevent="loginAsDemo('admin@admin.com')"
            >
              {{ $t('Admin area') }}
            </button>
            <button
              class="btn btn-secondary rounded-none rounded-r-md"
              type="button"
              @click.prevent="loginAsDemo('user@user.com')"
            >
              {{ $t('Workshop area') }}
            </button>
          </div>
        </div>
        <div class="mt-4 text-center text-gray-500">-------------------- OR --------------------</div>
      </template>

      <div class="mb-4 pt-1 relative rounded-md shadow-sm">
        <label class="input-label" for="email">
          {{ $t('Email') }}
        </label>
        <input
          :placeholder="$t('Email')"
          class="form-input mt-1"
          id="email"
          required
          type="text"
          v-model="user.email"
        />
      </div>
      <div class="mb-4 pt-1 relative rounded-md shadow-sm">
        <label class="input-label" for="password">
          {{ $t('Password') }}
        </label>
        <input
          :placeholder="$t('Password')"
          class="form-input mt-1"
          id="password"
          required
          type="password"
          v-model="user.password"
        />
      </div>
      <div class="mb-4 text-right">
        <button class="btn btn-app" id="submit-login" type="submit">
          {{ $t('Sign In') }}
        </button>
      </div>
      <p class="text-sm" v-if="$store.state.settings.register">
        {{ $t("Don't have an account?") }}
        <router-link class="align-baseline font-bold text-blue-700 hover:text-blue-900" to="/auth/register">
          {{ $t('Create account') }}
        </router-link>
      </p>
      <p class="text-sm">
        {{ $t('You can not access your account?') }}
        <router-link class="align-baseline font-bold text-blue-700 hover:text-blue-900" to="/auth/recover">
          {{ $t('Recover account') }}
        </router-link>
      </p>
    </form>
  </div>
</template>
<script>
import Cookies from 'js-cookie';
export default {
  name: 'login',
  metaInfo() {
    return {
      title: this.$i18n.t('Log In'),
    };
  },
  computed: {
    isDemoMode() {
      return this.$store.state.settings.is_demo_mode;
    },
  },
  data() {
    return {
      loading: false,
      user: {
        email: null,
        password: null,
        captcha_hash: null,
      },
    };
  },
  methods: {
    loginAsDemo(email) {
      this.user.email = email;
      this.user.password = '12345678';
      this.submit();
    },
    async submit() {
      this.loading = true;
      if (this.$store.state.settings.recaptcha_enabled) {
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha('login');
        this.user.captcha_hash = token;
        this.login();
      } else {
        this.login();
      }
    },

    login() {
      axios
        .post(route('auth.login'), this.user)
        .then((response) => {
          this.$store.commit('login', response.data);
          const intendedUrl = Cookies.get('intended_url');
          if (intendedUrl) {
            Cookies.remove('intended_url');
            this.$router.push(intendedUrl);
          } else {
            this.$router.push('/admin/dashboard');
          }
        })
        .catch(() => {
          this.loading = false;
          this.user.password = null;
        });
    },
  },
};
</script>
